import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    private loadingStatus = new Subject<any>();

    constructor() {}

    setLoadingStatus(message) {
        this.loadingStatus.next(message);
    }

    getLoadingStatus(): Observable<any> {
        return this.loadingStatus.asObservable();
    }
}
